import {
  css,
} from 'styled-components';

export const COLORS_LENGTH = 5;
export const exerciseColor = ({ theme, number }: any) => {
  const color = theme.colors.exerciseColors[number % COLORS_LENGTH || COLORS_LENGTH];

  return css`
    background-color: ${color || '#444'};
  `;
};
